import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, usePoliticalPartySearchDispatch, usePoliticalPartySearchState } from './political-party-search-context';

export const usePoliticalPartySearchController = () => {
    const navigate = useNavigate();
    const dispatch = usePoliticalPartySearchDispatch();
    const state = usePoliticalPartySearchState();

    function handleOnChange(e: any) {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: { ...state.parameters, term: e.target.value }
        });
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0 } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0, pageSize: 100, term: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() {
        navigate('/partidos-politicos/cadastrar');
    }

    function navigateToEdit(id: number) {
        navigate(`/partidos-politicos/editar/${id}`);
    }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToCreate, navigateToEdit };
};
